// utils/rybbit.js
/**
 * Rybbit Observability Integration
 * Loads the Rybbit tracking script dynamically
 */

export const initRybbit = () => {
  const siteId = process.env.REACT_APP_RYBBIT_SITE_ID;
  
  if (!siteId) {
    return;
  }
  
  // Check if script is already loaded
  if (document.querySelector(`script[data-site-id="${siteId}"]`)) {
    return;
  }
  
  const script = document.createElement('script');
  const rybbitUrl = process.env.REACT_APP_RYBBIT_URL || 'https://tracking.quadcorn.co.ke';
  
  script.src = `${rybbitUrl}/api/script.js`;
  script.defer = true;
  script.setAttribute('data-site-id', siteId);
  
  if (process.env.REACT_APP_RYBBIT_DEBOUNCE) {
    script.setAttribute('data-debounce', process.env.REACT_APP_RYBBIT_DEBOUNCE);
  }
  
  if (process.env.REACT_APP_RYBBIT_SKIP_PATTERNS) {
    try {
      const skipPatterns = JSON.parse(process.env.REACT_APP_RYBBIT_SKIP_PATTERNS);
      script.setAttribute('data-skip-patterns', JSON.stringify(skipPatterns));
    } catch (e) {
      // Ignore invalid skip pattern config
    }
  }
  
  if (process.env.REACT_APP_RYBBIT_MASK_PATTERNS) {
    try {
      const maskPatterns = JSON.parse(process.env.REACT_APP_RYBBIT_MASK_PATTERNS);
      script.setAttribute('data-mask-patterns', JSON.stringify(maskPatterns));
    } catch (e) {
      // Ignore invalid mask pattern config
    }
  }
  
  document.head.appendChild(script);
};

/**
 * Track custom events in Rybbit
 * @param {string} eventName - Name of the event
 * @param {object} properties - Event properties
 */
export const trackEvent = (eventName, properties = {}) => {
  if (typeof window !== 'undefined' && window.rybbit) {
    window.rybbit.event(eventName, properties);
  }
};

/**
 * Track page views (useful for SPAs)
 * @param {string} path - Page path
 */
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.rybbit) {
    window.rybbit.pageview(path);
  }
};
